import axios from "axios";
import config from "./config";
import { translate } from './i18n/customI18nProvider';
import { getLocale, setLocale, getToken, clear } from './services/storage';
import { Chip } from "@mui/material";
import Swal from "sweetalert2";

export async function request(url, method, token, request, useToken = true) {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    if (useToken) {
        if (token)
            headers['x-access-token'] = token;
        else if (getToken()) {
            headers['x-access-token'] = getToken();
        }
    }

    let options = {
        method,
        headers,
    };

    if (request) {
        options.body = JSON.stringify(request);
    }

    let responseJson;
    responseJson = await fetch(config.apiUrl + url, options);
    let response = await responseJson.json();

    if (response && response.error) {
        if(response.code === 102){
            clear();
            window.location.reload();
        }
        console.log(response.error);
    }

    return response;
}

export async function onpRequest(user_id, url, method, token, request, useToken = true) {    
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'onp-user-id': user_id
    };

    if (useToken) {
        if (token)
            headers['x-access-token'] = token;
        else
            headers['x-access-token'] = getToken();
    }

    let options = {
        method,
        headers,
    };

    if (request) {
        options.body = JSON.stringify(request);
    }

    let responseJson;
    responseJson = await fetch(config.apiUrl + "/v1/onp" + url, options);
    let response = await responseJson.json();

    if (response && response.error) {
        if(response.code === 102){
            clear();
            window.location.reload();
        }
        console.log(response.error);
    }

    return response;
}

// request with multipart form data
export async function requestMultipart(url, method, token, formDataRequestBody, useToken = true) {
    let headers = {
        'Content-Type': 'multipart/form-data'
    };

    if (useToken) {
        if (token)
            headers['x-access-token'] = token;
        else
            headers['x-access-token'] = getToken();
    }

    let options = {
        method,
        headers,
    };

    if (request) {
        options.body = request;
    }

    // let responseJson;
    // responseJson = await fetch(config.apiUrl + url, options);

    let response = await axios.post(config.apiUrl + url, formDataRequestBody,
        {
            mode: 'cors',
            headers: headers
        }
    )

    // let response = await responseJson.json();

    // if (response && response.error) {
    //     if(response.code === 102){
    //         clear();
    //         window.location.reload();
    //     }
    //     console.log(response.error);
    // }

    return response;
}

export function formatCurrencyWithCode(x, currencyCode=null) {
    let style = {};
    if (currencyCode) {
        style = { style: 'currency', currency: currencyCode };
    }
    return new Intl.NumberFormat('en', style).format(x);
}

export function formatCurrency(x){
    return new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(x).replace(/,/g, "'").replace('$', "");
}

export function formatCurrencySign(x){
    let sign = x < 0 ? '-' : (x=== 0 ? '' : '+');
    x = Math.abs(x);
    return sign + new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(x).replace(/,/g, "'").replace('$', "");
}

export function formatNumber(x){
    return new Intl.NumberFormat('en').format(x).replace(/,/g, "'");
}

export function gFormatCurrency(x){
    return {v: x, f: formatCurrency(x)};
}

export function gFormatNumber(x){
    return {v: x, f: formatNumber(x)};
}

export function objectIdFromDate(date) {
    return Math.floor(date.getTime() / 1000).toString(16) + "0000000000000000";
}

export function dateFromObjectId(objectId) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
    // return String(parseInt(objectId.substring(0, 8), 16) * 1000);
}

export function getLabel(index, label){
    for(let i in label)
        if(index === label[i].value)
            return label[i].name;
    return "Non défini";
}

export function getChoices(values, type=null, sub_unit='', unit=''){
    return Object.entries(values).map((a) => {

        if (type === 'currency') {
            if (a[1].value < 1) {
                return {id: a[1].value, name: (parseInt(parseFloat(a[1].name) * 100)) + ' ' + sub_unit}
            } else {
                return {id: a[1].value, name: a[1].name + ' ' + unit}
            }
        } else {
            return {id: a[1].value, name: a[1].name}
        }
    });
}

export function getCompleteByPaymentChoices() {
    const choices = [];
    Object.entries(config.payment_types).forEach((a) => {
        if([config.payment_types.CASH.value, config.payment_types.CARD.value].includes(a[1].value)) return;
        choices.push({id: a[1].value, name: a[1].description});
    });
    return choices;
}

export function getHybridPaymentChoices() {
    const choices = [{id: 'wristband', name: translate('custom.wristband')}];
    Object.entries(config.payment_types).forEach((a) => {
        if([config.payment_types.CARD.value].includes(a[1].value)) return;
        choices.push({id: a[1].value, name: a[1].description});
    });
    return choices;
}

export function getHybridRefundChoices() {
    const choices = [{id: 'wristband', name: translate('custom.wristband')}];
    Object.entries(config.payment_types).forEach((a) => {
        if([config.payment_types.TWINT.value, config.payment_types.TWINT_DIRECT.value, config.payment_types.CARD.value].includes(a[1].value)) return;
        choices.push({id: a[1].value, name: a[1].description});
    });
    return choices;
}

export function getCheckoutClientRefundChoices() {
    const choices = [];
    Object.entries(config.checkout_methods).forEach((a) => {
        choices.push({id: a[1].value, name: a[1].description});
    });
    return choices;
}

export async function languageCheckAndReload(lang=null) {
    if(!lang) {
        let parameterLanguage = await request('/events/parameter/language', 'GET');
        lang = parameterLanguage.language;
    }
    if (lang && (lang != getLocale())) {
        setLocale(lang)
        window.location.reload();
    }
}

export function fillMessageVariable(message, payload={}) {
    // message = I would like to donation |currency_code| |amount| which will be used to cover the transaction charges.
    // payload = {currency_code: 'USD', amount: '100.00'}
    // return I would like to donation USD 100.00 which will be used to cover the transaction charges.
    let codes = message.match(/(?:\|)[^\|\|]*?(?:\|)/g) || [];
    let newMessage = message;
    for(let i=0; i<codes.length; i++){
        let code = codes[i].replace(/\|/g, '');
        newMessage = newMessage.replace(codes[i], payload[code]);
    }
    return newMessage;
}

export function convertMessageCodeToMessage(messageCode){
    let codes = messageCode.match(/(?:\|)[^\|\|]*?(?:\|)/g) || [];
    let message = messageCode;
    for(let i=0; i<codes.length; i++){
        message = message.replace(codes[i], translate('custom.'+codes[i].replace(/\|/g, '')));
    }
    return message;
}

export function getRequestOptions(method) {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    headers['x-access-token'] = getToken();

    let options = {
        method: method,
        headers
    };

    return options;
}

export async function downloadFileFromResponse(response, file_name, axios=false) {
    let blob;
    if(axios) {
        blob = await response.data;
    } else {
        blob = await response.blob();
    }
    const newBlob = new Blob([blob]);
    const blobUrl = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(blob);
}

export function booleanToChip(value) {
    return value ? <Chip label={translate('custom.yes')} color="success" /> : <Chip label={translate('custom.no')} color="error" />;
}

export function optionsToChip(value, color = "primary") {
    return <Chip label={value} color={color} />;
}

export function generateRandomString(length) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function notifyError(error) {
    let message = translate('custom.an_error_occured');
    if (error && error.message) message = error.message;
    if (error && error.error) message = error.error;
    if (typeof error === 'string' && error != "") message = error;
    
    Swal.fire({
        toast: true,
        position: 'bottom',
        icon: 'error',
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    });
}

export function notifyWarning(message) {
    Swal.fire({
        toast: true,
        position: 'bottom',
        icon: 'warning',
        title: translate(message),
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    });
}

export function notifySuccess(message) {
    Swal.fire({
        toast: true,
        position: 'bottom',
        icon: 'success',
        title: translate(message),
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
    });
}

export function notifyConfirm(message) {
    return Swal.fire({
        title: translate(message),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translate('custom.yes'),
        cancelButtonText: translate('custom.no')
    });
}

export function askModal(question, options) {
    return Swal.fire({
        title: translate(question),
        showCancelButton: true,
        input: 'radio',
        inputOptions: options,
        inputValidator: (value) => {
            if (!value) return translate('custom.you_need_to_choose_something');
        },
        confirmButtonText: translate('custom.confirm'),
        cancelButtonText: translate('custom.cancel')
    });
    
}

export function askInput(question, placeholder, type='text') {
    return Swal.fire({
        title: translate(question),
        input: type,
        inputPlaceholder: translate(placeholder),
        showCancelButton: true,
        confirmButtonText: translate('custom.confirm'),
        cancelButtonText: translate('custom.cancel')
    });
}

export function startLoading(message = translate('custom.loading')) {
    Swal.fire({
        title: translate(message),
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
}

export function stopLoading(status = "success", message = translate('custom.done')) {
    Swal.close();
    Swal.fire({        
        icon: status,
        title: translate(message),
        allowOutsideClick: true,
        allowEscapeKey: true,
        showConfirmButton: false,
        timer: 1500
    });
}

export function dateToLocalString(date) {
    if (!date) return '';
    const d = new Date(date);
    const offset = d.getTimezoneOffset();
    const localDate = new Date(d.getTime() - (offset * 60 * 1000));
    return localDate.toISOString().substring(0, 16);
}